import React, { FC } from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { Search } from 'components/page-header/search';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import HeaderLogo from 'components/page-header/header-logo';
import LanguageSelector from 'components/page-header/language-selector';
import HeaderNavbar from 'components/page-header/header-navbar';
import {
  DocumentationHeaderFragment,
  DocumentationHeaderSubMenu,
  LanguageItemFragment,
  LanguageMenuFragment,
} from 'graphql/__generated__/types';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ElasticSearch } from '../elastic-search';
import { Authentication } from '../authentication/authentication';

interface PageHeaderDesktopProps {
  headerData: DocumentationHeaderFragment;
}

const PageHeaderDesktop: FC<PageHeaderDesktopProps> = ({ headerData }) => {
  const { logo, searchBox, languageMenu, primaryNavigation, authentication, secondaryNavigation, hubName } = headerData;
  const { subMenus, leadingIcon, trailingIcon } = languageMenu as LanguageMenuFragment;
  const { items } = subMenus[0] as DocumentationHeaderSubMenu;
  return (
    <UitkSpacing padding={{ inline: 'four' }}>
      <UitkLayoutFlex direction="column" justifyContent="space-between" className="height-full">
        <UitkLayoutFlexItem grow={1}>
          <UitkLayoutGrid columns={12} alignItems="center" justifyContent="space-between">
            <UitkLayoutGridItem colSpan={{ small: 12, medium: 9, large: 7, extra_large: 5 }}>
              <UitkLayoutFlex space="six" alignItems="center">
                <UitkLayoutFlexItem>
                  <div>
                    <HeaderLogo logo={logo} hubName={hubName} />
                  </div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem grow={1}>
                  <div data-testid="searchbox">
                    <Experiment name="DevHub_Search_Behind_Login">
                      <ExperimentControl>
                        <Search searchInputProps={searchBox} />
                      </ExperimentControl>
                      <ExperimentVariant bucket={1}>
                        <ElasticSearch searchInputProps={searchBox} />
                      </ExperimentVariant>
                    </Experiment>
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem colSpan={{ medium: 3, large: 5, extra_large: 7 }}>
              <UitkLayoutFlex justifyContent="end" space="three">
                <UitkLayoutFlexItem>
                  <LanguageSelector
                    languages={items as Array<LanguageItemFragment>}
                    leadingIcon={leadingIcon.token}
                    trailingIcon={trailingIcon.token}
                  />
                </UitkLayoutFlexItem>
                <Experiment name="DevHub_AuthN_AuthZ">
                  <ExperimentControl>
                    <></>
                  </ExperimentControl>
                  <ExperimentVariant bucket={1}>
                    <UitkLayoutFlexItem>
                      <Authentication authentication={authentication} />
                    </UitkLayoutFlexItem>
                  </ExperimentVariant>
                </Experiment>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <HeaderNavbar primaryNavigation={primaryNavigation} secondaryNavigation={secondaryNavigation} />
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default PageHeaderDesktop;
